import { useMutation, useQueryClient } from '@tanstack/react-query';
import ApiService from 'src/services/ApiService';

export const useRuleUpdateByIdMutation = (checklistId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['/rules' as const],
    mutationFn: ApiService.rules.updateRuleById,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['/tenant/checklist', checklistId],
      });
    },
  });
};
